import React, { useState, useEffect } from "react";
import Buttons from "../../shared/Buttons/Buttons";
import { BsFillEyeFill } from "react-icons/bs";
import { BsFillEyeSlashFill } from "react-icons/bs";
import {
  InputDiv,
  Label,
  TextColor,
  Input,
} from "../../assets/StyledComponent/Input/Input.Style";
import { SubmitHandler, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import DFS from "../../assets/images/dfs.png";
import { loginService } from "../../services/LoginService";
import { userSpecificService } from "../../services/UserService";
import { toast } from "react-toastify";

import { NavLink, useNavigate } from "react-router-dom";
import {
  Container,
  ButtonWrapper,
  ContentWrapper,
  InputWrapper,
  Header,
  Wrapper,
  OverallWrapper,
  LogoImage,
  InputHeader,
} from "./Login.Style";

import { LOG_IN, SET_ROLE } from "./types";
// import { redirectNavigation } from "../../utils/RoleUtils";
import { useStore } from "../../store";
import { USER_REPORT_CLEAR } from "../../container/user/types";

type Inputs = {
  username: string;
  password: string;
};

const schema: yup.SchemaOf<Partial<Inputs>> = yup.object({
  username: yup.string().email().required(),
  password: yup.string().required(),
});

const LogIn: React.FC = () => {
  const navigate = useNavigate();
  // const location: any = useLocation();

  const [, dispatch]: any = useStore();
  const [redirect, setRedirect] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { register, handleSubmit, formState } = useForm<Inputs>({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    dispatch({ type: USER_REPORT_CLEAR });
    userSpecificService().then((res: any) => {
      dispatch({
        type: SET_ROLE,
        role: res.roles.name,
      });

      if (res.roles.name === "super_admin") {
        navigate("/spadmin", { replace: true });

        toast.success("Login Successful");
      } else if (res.roles.name === "admin") {
        navigate("/admin", { replace: true });

        toast.success("Login Successful");
      } else if (res.roles.name === "system_admin") {
        navigate("/cadmin", { replace: true });

        toast.success("Login Successful");
      } else if (res.roles.name === "user") {
        navigate("/userdashboard", { replace: true });

        toast.success("Login Successful");
      }
    });
  }, [navigate, redirect]);

  const validate_form: SubmitHandler<Inputs> = (data: Inputs) => {
    if (data) {
      loginService(data)
        .then((res) => {
          // console.log("LOGIN SERVICE DATA==>", res);
          if (!!res.access_token) {
            dispatch({
              type: LOG_IN,
              payload: {
                token: res.access_token,
                refreshToken: res.refresh_token,
              },
            });
            res.redirect && navigate("/change-password", { replace: true });
            setRedirect(!redirect);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };

  return (
    <Container>
      <OverallWrapper>
        <div>
          <Wrapper>
            <Header>{<LogoImage src={DFS} />}</Header>
          </Wrapper>
        </div>
        <ContentWrapper>
          <Wrapper>
            <InputHeader>Welcome Back</InputHeader>

            {/* <InputText>Enter your credentials to access your account</InputText> */}
            <InputWrapper>
              <form
                onSubmit={handleSubmit(validate_form)}
                className="w-100 mx-auto"
              >
                <Wrapper>
                  <InputWrapper>
                    <InputDiv>
                      <Label>Email</Label>
                      <Input type="text" {...register("username")} />
                      <TextColor>
                        {formState.errors.username?.message}
                      </TextColor>
                    </InputDiv>

                    <InputDiv>
                      <Label>Password</Label>
                      <div
                        className="d-flex align-items-center w-100"
                        style={{
                          backgroundColor: "white",
                          position: "relative",
                          borderRadius: "5px",
                        }}
                      >
                        <Input
                          type={showPassword ? "text" : "password"}
                          {...register("password")}
                        />

                        {showPassword ? (
                          <BsFillEyeFill
                            onClick={() => setShowPassword(false)}
                            style={{
                              position: "absolute",
                              right: "14px",
                            }}
                          />
                        ) : (
                          <BsFillEyeSlashFill
                            onClick={() => setShowPassword(true)}
                            style={{
                              position: "absolute",
                              right: "14px",
                            }}
                          />
                        )}
                      </div>
                      <TextColor>
                        {formState.errors.password?.message}
                      </TextColor>
                    </InputDiv>
                    <ButtonWrapper>
                      <Buttons buttonType="normalButton" buttonTitle="login" />
                    </ButtonWrapper>
                    <NavLink
                      to="/forgot_password"
                      style={{
                        textDecoration: "none",
                        padding: "0px",
                        marginBottom: "12px",
                        textAlign: "center",
                        fontSize: "13px",
                        color: "#4492CF",
                        fontWeight: "500",
                      }}
                    >
                      Forgot Password?
                    </NavLink>
                  </InputWrapper>
                </Wrapper>
              </form>
            </InputWrapper>
          </Wrapper>
        </ContentWrapper>
      </OverallWrapper>
    </Container>
  );
};

export default LogIn;
